import { render, staticRenderFns } from "./FileConfirm.vue?vue&type=template&id=32374544&scoped=true&"
import script from "./FileConfirm.vue?vue&type=script&lang=js&"
export * from "./FileConfirm.vue?vue&type=script&lang=js&"
import style0 from "./FileConfirm.vue?vue&type=style&index=0&id=32374544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32374544",
  null
  
)

export default component.exports